<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <h2 class="ui primary header">Company Affiliate Types</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button class="ui small button primary" (click)="addAffiliateType()">
        Add affiliate type
      </button>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>

  <div class="ui vertical basic segment" *ngIf="success || error">
    <div *ngIf="success || error">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
  </div>
  <!-- </div> -->
  <div
    fxLayout="row"
    appMargin
    class="ui segment"
    marginB="3"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    id="dark"
  >
    <div fxFlex="30%">COMPANY TYPE</div>
    <div fxFlex="grow">AFFILIATE TYPES</div>
    <div fxFlex="10%"></div>
  </div>
  <div
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
    appMargin="0"
    appPadding="0"
  >
    <div
      *ngFor="let companyRecord of recordsToDisplay; let i = index"
      appMargin
      marginB="3"
      appPadding
      paddingB="0"
    >
      <div
        class="ui attached segment"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
      >
        <div fxFlex="30%">{{ companyRecord?.companyTypeName }}</div>
        <div fxFlex="grow">{{ companyRecord?.answer }}</div>
        <div fxFlex="10%">
          <button
            class="ui tiny circular icon button"
            (click)="toggleAffiliateTypesVisibility(i)"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            [popupText]="
              companyRecord?.isCollapsed
                ? 'Show Affiliate Types'
                : 'Hide Affiliate Types'
            "
          >
            <i
              [class]="
                companyRecord?.isCollapsed
                  ? 'chevron down icon'
                  : 'chevron up icon'
              "
            ></i>
          </button>
          <button
            class="ui tiny circular icon primary button"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            popupText="Add Affiliate Type"
            (click)="addAffiliateType(companyRecord?.companyTypeId)"
          >
            <i class="plus icon"></i>
          </button>
        </div>
      </div>

      <div [suiCollapse]="companyRecord?.isCollapsed">
        <div class="ui bottom attached segment" appPadding="0">
          <app-affiliate-type-list
            [affiliateTypes]="companyRecord.companyTypeHasOwnershipTypes"
            (removeIndividual)="removeIndividual($event)"
          ></app-affiliate-type-list>
        </div>
      </div>
    </div>

    <app-no-record-found
      *ngIf="companyRecords && companyRecords.length < 1"
    ></app-no-record-found>
  </div>

  <div class="ui vertical basic segment">
    <div class="ui two column grid">
      <div class="column middle aligned">
        <div class="ui icon small button">
          <i class="database icon"></i>
        </div>
        <a class="ui basic label">{{ totalItems }} Record(s)</a>
      </div>
      <div
        class="column right aligned pagination menu"
        style="margin-left: auto"
      >
        <sui-pagination
          class="small"
          [collectionSize]="totalItems"
          [pageSize]="rows"
          [maxSize]="maxSize"
          [hasEllipses]="false"
          [page]="currentPage"
          (pageChange)="nextPage($event)"
        >
        </sui-pagination>
      </div>
    </div>
  </div>
</div>
